import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsDevicesDeviceModel } from 'src/api/generated';
import { PagedResponse } from 'src/types/GlobalTypes';
import { buildQueryParams } from 'src/hooks/api/helpers';

export const DEVICES_URI = 'devices';

export const devicesQueries = createQueryKeys(DEVICES_URI, {
  all: null,
  list: (page?: number, pageSize?: number, venueId?: string, type?: string, status?: string) => ({
    queryKey: ['list', page, pageSize, venueId, type, status],
    queryFn: async () => {
      const response = await get<PagedResponse<FanguardApiContractsDevicesDeviceModel>>({
        uri: `${DEVICES_URI}?${buildQueryParams({ page, pageSize, venueId, type, status })}`,
      });
      return response.data;
    },
  }),
});
